
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const NocodeHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    setIsMenuOpen(false);
    
    if (id === '') {
      // If home is clicked, scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 w-full ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-2' : 'bg-black/30 backdrop-blur-sm py-4'}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/nocode" onClick={() => scrollToSection('')} className="flex items-center">
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className="flex items-center"
            >
              <img 
                src="/lovable-uploads/375b4c15-6f7f-4840-b254-2a82666f405f.png" 
                alt="LovaBuild Logo" 
                className="w-8 h-8 mr-2"
              />
              <span className="font-montserrat font-bold text-xl">
                <span className={isScrolled ? 'text-gray-800' : 'text-white'}>LovaBuild</span>
              </span>
            </motion.div>
          </Link>
          
          {/* CTA Button */}
          <button
            onClick={() => {
              window.scrollTo(0, 0);
              navigate('/nocode/onboarding');
            }}
            className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-black font-montserrat font-medium rounded-full px-6 py-2 text-sm hover:shadow-lg hover:scale-105 transition-all duration-300"
          >
            Start Now
          </button>
          
          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-nocode-blue"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke={isScrolled ? 'currentColor' : 'white'}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>
      
    </header>
  );
};

export default NocodeHeader;
